<template>
  <div
    class="admin-table-outer-wrapper"
    :class="{ 'table-overflows-x': tableOverflowsX }"
    :style="moduloLayout ? { '--ct-toolbar-h': '32px' } : null"
  >
    <!-- Toolbar acima do grid (fora do scroll horizontal) -->
    <div v-if="moduloLayout" ref="toolbarRef" class="admin-table-toolbar">
      <button
        type="button"
        class="btn-layout-config"
        :class="{ 'btn-layout-config-visible': isLayoutModalOpen }"
        @click="abrirGerenciadorLayout"
        title="Gerenciar layouts desta tabela"
      >
        <i class="bi bi-layout-three-columns"></i>
      </button>

      <button
        ref="btnColunasSelectorRef"
        type="button"
        class="btn-layout-config btn-colunas-selector"
        :class="{ 'btn-layout-config-visible': showColunasSelector }"
        @click="showColunasSelector = !showColunasSelector"
        title="Selecionar colunas para exibir"
      >
        <i class="bi bi-gear"></i>
      </button>

      <!-- Botão de exportar -->
      <div ref="btnExportarRef" class="btn-exportar-wrapper">
        <button
          type="button"
          class="btn-layout-config btn-exportar"
          :class="{ 'btn-layout-config-visible': showExportMenu }"
          @click="showExportMenu = !showExportMenu"
          title="Exportar dados"
        >
          <i class="bi bi-download"></i>
        </button>
      </div>

      <!-- Barra de progresso de exportação -->
      <div v-if="exportandoProgresso.total > 0" class="exportar-progresso-wrapper">
        <div class="exportar-progresso-bar">
          <div
            class="exportar-progresso-fill"
            :style="{ width: progressoPorcentagem + '%' }"
          ></div>
        </div>
        <span class="exportar-progresso-texto">
          Carregando {{ exportandoProgresso.carregados }} / {{ exportandoProgresso.total }} registros...
        </span>
      </div>

    </div>

    <div
      ref="tableContainerRef"
      class="admin-table-container"
      :class="{
        'is-resizing': isResizing,
        'has-sticky-actions': !!internalSelectedKey
      }"
    >
      <table
        class="admin-table"
        :class="{ 'table-hover': hover !== false }"
        ref="tableRef"
      >
      <thead>
       <tr>
         <th
           v-for="col in colunasRenderizadas"
            :key="col.field"
            :style="thStyle(col)"
            :class="[
              col.class,
              'th-sortable',
              { 'th-sorted': sortField === col.field },
              { 'th-actions': col.field === 'acoes' || col.field === 'actions' }
            ]"
            :data-field="col.field"
          >
            <div class="th-content" @click="handleHeaderClick(col)">
              <span class="th-label">{{ col.label }}</span>
              <span class="sort-indicator ms-1">
                <i
                  v-if="sortField !== col.field"
                  class="bi bi-sort text-muted"
                ></i>
                <i
                  v-else-if="sortOrder === 'asc'"
                  class="bi bi-sort-up"
                ></i>
                <i v-else class="bi bi-sort-down"></i>
              </span>
            </div>
            <div
              v-if="col.resizable !== false"
              class="resize-handle"
              @mousedown.prevent="onResizeStart($event, col.field)"
            ></div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!localData || localData.length === 0">
          <td :colspan="colunasRenderizadas.length" class="text-center text-muted py-4">
            <slot name="empty">{{ emptyMessage }}</slot>
          </td>
        </tr>
        <tr
          v-for="(row, rowIndex) in localData"
          :key="getRowKey(row, rowIndex)"
          :class="[
            { selected: isRowSelected(row, rowIndex) },
            props.rowClass ? props.rowClass(row) : ''
          ]"
          @click="handleRowClick(row, $event)"
        >
          <td
            v-for="col in colunasRenderizadas"
            :key="col.field"
            :class="[
              col.class,
              { 'td-actions': col.field === 'acoes' || col.field === 'actions' }
            ]"
            :style="{ textAlign: col.align || 'left' }"
          >
            <slot
              v-if="col.slotName"
              :name="col.slotName"
              :row="row"
              :index="rowIndex"
            ></slot>
            <span v-else-if="col.allowHtml" v-html="col.formatter ? col.formatter(campoResolvido(row, col.field), row) : campoResolvido(row, col.field)"></span>
            <span v-else>
              {{ col.formatter ? col.formatter(campoResolvido(row, col.field), row) : campoResolvido(row, col.field) }}
            </span>
          </td>
        </tr>
      </tbody>
      </table>
    </div>

    <!-- Teleport: Dropdown de exportação -->
    <Teleport to="body">
      <div v-if="showExportMenu" class="exportar-dropdown" :style="exportarDropdownStyle" @click.stop>
        <button class="exportar-opcao" @click="exportarDados('csv')">
          <i class="bi bi-filetype-csv me-1"></i> .csv
        </button>
        <button class="exportar-opcao" @click="exportarDados('xlsx')">
          <i class="bi bi-file-earmark-spreadsheet me-1"></i> .xlsx
        </button>
      </div>
    </Teleport>

    <!-- Teleport: Popover de seleção de colunas (dual-pane) -->
    <Teleport to="body">
      <div v-if="showColunasSelector" class="colunas-selector-popover" :style="colunasPopoverStyle" @click.stop>
        <div class="colunas-selector-panes">
          <!-- Painel ESQUERDO: Disponíveis -->
          <div class="colunas-pane">
            <div class="pane-header">
              <span class="pane-title">📦 Disponíveis</span>
              <div class="pane-header-actions">
                <button
                  type="button"
                  class="btn-pane-select-all"
                  @click="selecionarTudo"
                  title="Selecionar todos os campos disponíveis"
                >
                  <i class="bi bi-chevron-double-right"></i>
                </button>
                <span class="pane-count">{{ colunasDisponiveis.length }}</span>
              </div>
            </div>
            <input
              type="text"
              class="pane-filter-input"
              v-model="filtroDisponiveis"
              placeholder="Filtrar disponíveis..."
              @keydown.escape="filtroDisponiveis = ''"
            />
            <div
              class="pane-body"
              @dragover.prevent="onDragOverPane('disponiveis')"
              @drop="onDropPane('disponiveis')"
            >
              <div
                v-for="col in colunasDisponiveisFiltradas"
                :key="col.field"
                class="pane-item"
                :class="{ 'pane-item-drop-before': dragOverField === col.field }"
                draggable="true"
                @dragstart="onDragStart(col.field, 'disponiveis')"
                @dragover.prevent="onDragOverItem(col.field, 'disponiveis')"
                @dragleave="onDragLeaveItem"
                @drop="onDropItem(col.field, 'disponiveis')"
                @dblclick="toggleColuna(col.field)"
              >
                <input
                  type="checkbox"
                  class="form-check-input"
                  @change="toggleColuna(col.field)"
                />
                <span class="pane-item-text">{{ col.label }}</span>
              </div>
              <div v-if="colunasDisponiveisFiltradas.length === 0" class="pane-empty">
                Nenhum campo disponível.
              </div>
            </div>
          </div>

          <!-- Painel DIREITO: Selecionados -->
          <div class="colunas-pane">
            <div class="pane-header">
              <span class="pane-title">✅ Selecionados</span>
              <div class="pane-header-actions">
                <button
                  type="button"
                  class="btn-pane-deselect-all"
                  @click="demarcarTodos"
                  title="Demarcar todos os campos selecionados"
                >
                  <i class="bi bi-chevron-double-left"></i>
                </button>
                <span class="pane-count">{{ colunasSelecionadas.length }}</span>
              </div>
            </div>
            <input
              type="text"
              class="pane-filter-input"
              v-model="filtroSelecionados"
              placeholder="Filtrar selecionados..."
              @keydown.escape="filtroSelecionados = ''"
            />
            <div
              class="pane-body"
              @dragover.prevent="onDragOverPane('selecionados')"
              @drop="onDropPane('selecionados')"
            >
              <div
                v-for="col in colunasSelecionadasFiltradas"
                :key="col.field"
                class="pane-item"
                :class="{
                  'pane-item-fixed': isPrimeiraColuna(col.field) || isColunaAcoes(col.field),
                  'pane-item-drop-before': dragOverField === col.field
                }"
                :draggable="!isPrimeiraColuna(col.field) && !isColunaFixa(col.field)"
                @dragstart="onDragStart(col.field, 'selecionados')"
                @dragover.prevent="onDragOverItem(col.field, 'selecionados')"
                @dragleave="onDragLeaveItem"
                @drop="onDropItem(col.field, 'selecionados')"
                @dblclick="!isPrimeiraColuna(col.field) && !isColunaFixa(col.field) && toggleColuna(col.field)"
              >
                <template v-if="isPrimeiraColuna(col.field)">
                  <span class="pane-star" title="Campo obrigatório — não pode ser desmarcado nem reposicionado">⭐</span>
                </template>
                <template v-else-if="isColunaAcoes(col.field)">
                  <span class="pane-lock" title="Coluna de ações — não pode ser desmarcada nem reposicionada">🔒</span>
                </template>
                <template v-else-if="isColunaFixa(col.field)">
                  <span class="pane-lock" title="Campo obrigatório — não pode ser desmarcado, mas pode ser reposicionado">🔒</span>
                </template>
                <input
                  v-else
                  type="checkbox"
                  class="form-check-input"
                  checked
                  @change="toggleColuna(col.field)"
                />
                <span class="pane-item-text">{{ col.label }}</span>
                <div v-if="!isPrimeiraColuna(col.field) && !isColunaFixa(col.field)" class="pane-item-arrows">
                  <button
                    type="button"
                    class="btn-arrow-colunas"
                    @click="moverColuna(col.field, -1)"
                    title="Mover para cima"
                  >
                    <i class="bi bi-chevron-up"></i>
                  </button>
                  <button
                    type="button"
                    class="btn-arrow-colunas"
                    :disabled="isUltimaColuna(col.field)"
                    @click="moverColuna(col.field, 1)"
                    title="Mover para baixo"
                  >
                    <i class="bi bi-chevron-down"></i>
                  </button>
                </div>
                <span v-if="!isPrimeiraColuna(col.field) && !isColunaFixa(col.field)" class="drag-handle" title="Arrastar para reordenar">⠿</span>
              </div>
              <div v-if="colunasSelecionadasFiltradas.length === 0" class="pane-empty">
                Nenhum campo selecionado.
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Modal de Gerenciamento de Layouts -->
    <GerenciadorLayoutModal
      v-if="moduloLayout"
      :model-value="isLayoutModalOpen"
      :modulo="moduloLayout"
      :colunas-disponiveis="colunasPadrao"
      :layout-atual="layoutAtualSnapshot"
      @update:model-value="isLayoutModalOpen = $event"
      @aplicar-layout="aplicarLayoutExterno"
      @show-notification="emit('show-notification', $event)"
    />
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, nextTick } from 'vue'
import * as XLSX from 'xlsx'
import GerenciadorLayoutModal from './GerenciadorLayoutModal.vue'
import { layoutService } from '@/services/layoutService'
import { useResolverListas } from '@/composables/useResolverListas'
import { reservarZIndex, liberarZIndex, BASE_ZINDEX } from '@/composables/useZIndex'

const props = defineProps({
  columns: { type: Array, required: true },
  data: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  emptyMessage: { type: String, default: 'Nenhum registo encontrado.' },
  sortField: { type: String, default: '' },
  sortOrder: { type: String, default: '' },
  hover: { type: Boolean, default: true },
  rowKey: { type: String, default: '' },
  sortResolver: { type: Function, default: null },

  // ============================================================
  // Sistema de Layouts Customizáveis
  // ============================================================
  // Quando definido (ex: 'MovimentacoesEstoque'), ativa o botão
  // e o gerenciador de layouts para esta tabela.
  moduloLayout: { type: String, default: null },
  // Definição original de TODAS as colunas disponíveis do módulo
  // (usado pelo gerenciador para mostrar/esconder colunas)
  colunasPadrao: { type: Array, default: null },

  // ============================================================
  // Resolução automática de listas (Lst* → {campo}Texto)
  // ============================================================
  // Quando informado o nome da tabela no Dicionário de Metadados
  // (ex: 'PedidoVenda'), o AdminTable resolve os campos Lst* para o
  // texto amigável (textoLista), injetando {campo}Texto nos itens via
  // useResolverListas, tanto na exibição quanto na exportação.
  // Aceita uma única tabela (string) ou múltiplas tabelas (array) para
  // fallback sequencial (ex: ['ReservaEstoque', 'ReservaEstoqueItem']).
  // Prop é OPCIONAL: sem ela, o comportamento é o anterior (valor bruto).
  resolverListasTabela: { type: [String, Array], default: null },

  // ============================================================
  // Bloqueio da primeira coluna
  // ============================================================
  // Quando true (padrão), a primeira coluna do painel "Selecionados"
  // fica fixa: não pode ser ocultada, reordenada nem arrastada.
  // Passe false para permitir que o usuário gerencie livremente.
  bloquearPrimeiraColuna: { type: Boolean, default: true },

  // ============================================================
  // Colunas fixas (não podem ser removidas do relatório)
  // ============================================================
  // Array de field names que não podem ser desmarcados no seletor
  // de colunas. Podem ser reordenados, mas não removidos.
  // Ex: ['produto', 'filial']
  colunasFixas: { type: Array, default: () => [] },

  // ============================================================
  // Exportação de dados
  // ============================================================
  // Objeto de progresso da exportação: { total, carregados }
  exportandoProgresso: { type: Object, default: () => ({ total: 0, carregados: 0 }) },
  // Array com todos os dados filtrados para exportar (quando pronto)
  dadosExportar: { type: Array, default: null },

  // ============================================================
  // Metadados para exportação (incluídos como cabeçalho no arquivo)
  // ============================================================
  // Título do relatório (ex: "Saldos em Estoque")
  tituloExportacao: { type: String, default: '' },
  // Descrição textual dos filtros aplicados (ex: "Produtos: [ABC, XYZ] | Filial: Matriz")
  filtrosExportacao: { type: String, default: '' },

  // ============================================================
  // Seleção de linha
  // ============================================================
  // Quando true, permite selecionar uma linha com clique
  selectable: { type: Boolean, default: true },
  // Key da linha selecionada (v-model suportado)
  selectedRowKey: { type: [String, Number], default: null },
  // Função (row) => string para classes CSS adicionais por linha
  rowClass: { type: Function, default: null }
})

const emit = defineEmits([
  'update:sortField',
  'update:sortOrder',
  'sort-change',
  'row-click',
  'row-dblclick',
  'show-notification',
  'exportar-dados',
  'group-by-changed',
  'update:selectedRowKey',
  'selected-row-change'
])

// ============================================================
// Row Key Helper (deve vir antes de qualquer watch que o use)
// ============================================================
const getRowKey = (row, index) => {
  if (props.rowKey) {
    const val = row[props.rowKey]
    if (val !== undefined && val !== null && val !== '') {
      return val
    }
  }
  // Tenta usar o field da primeira coluna como fallback
  const firstField = props.columns[0]?.field
  if (firstField && row[firstField] !== undefined && row[firstField] !== null) {
    return row[firstField]
  }
  return index
}

// ============================================================
// Resolução automática de listas (Lst* → {campo}Texto)
// ============================================================
const { resolverListasEmLote, campoResolvido } = useResolverListas()

// ============================================================
// Local data mirror for client-side sorting
// ============================================================
const localData = ref([...props.data])

watch(
  () => props.data,
  async (newData) => {
    // Resolve campos Lst* para texto amigável ANTES de espelhar no localData,
    // para que o Proxy do Vue capture os campos {campo}Texto resolvidos.
    if (props.resolverListasTabela) {
      const dados = newData || []
      await resolverListasEmLote(dados, props.resolverListasTabela)
      localData.value = [...dados]
      return
    }
    localData.value = [...newData]
  },
  { deep: true, immediate: true }
)

// ============================================================
// Resize State
// ============================================================
const columnWidths = ref({})
const isResizing = ref(false)
const tableRef = ref(null)
const tableContainerRef = ref(null)
const toolbarRef = ref(null)
const btnColunasSelectorRef = ref(null)
const btnExportarRef = ref(null)

// ============================================================
// Detector de overflow horizontal
// Mantém o `thead` sticky referenciando a PÁGINA (container sem overflow)
// no caso comum; só ativa .table-overflows-x quando a tabela realmente
// excede a largura do container (mitigação de layout).
// ============================================================
const tableOverflowsX = ref(false)
let _overflowObserver = null

const checarOverflowX = () => {
  const container = tableContainerRef.value
  const table = tableRef.value
  if (!container || !table) return
  tableOverflowsX.value = table.scrollWidth > container.clientWidth + 1
}

let resizeState = null

const onResizeStart = (event, field) => {
  const th = event.target.closest('th')
  if (!th) return

  const startWidth = th.offsetWidth
  const minWidth = getMinWidthForColumn(field)

  resizeState = { field, startX: event.clientX, startWidth, minWidth }
  isResizing.value = true

  document.documentElement.style.userSelect = 'none'
  document.documentElement.style.cursor = 'col-resize'

  document.addEventListener('mousemove', onResizeMove)
  document.addEventListener('mouseup', onResizeEnd)
}

const onResizeMove = (event) => {
  if (!resizeState) return

  const deltaX = event.clientX - resizeState.startX
  const newWidth = Math.max(resizeState.minWidth, resizeState.startWidth + deltaX)

  columnWidths.value[resizeState.field] = Math.round(newWidth)
}

const onResizeEnd = () => {
  cleanupResize()
}

const cleanupResize = () => {
  resizeState = null
  isResizing.value = false

  document.documentElement.style.userSelect = ''
  document.documentElement.style.cursor = ''

  document.removeEventListener('mousemove', onResizeMove)
  document.removeEventListener('mouseup', onResizeEnd)
}

onUnmounted(() => {
  if (resizeState) cleanupResize()
  document.removeEventListener('click', handleClickOutside)
  window.removeEventListener('scroll', onReposicionarOverlays, { capture: true })
  window.removeEventListener('resize', onReposicionarOverlays, { capture: true })
  liberarZIndex(tokenZIndexColunas.value)
  tokenZIndexColunas.value = null
  liberarZIndex(tokenZIndexExportar.value)
  tokenZIndexExportar.value = null
  if (_overflowObserver) {
    _overflowObserver.disconnect()
    _overflowObserver = null
  }
})

const getMinWidthForColumn = (field) => {
  const col = (props.columns || []).find((c) => c.field === field)
  return col?.minWidth ?? 60
}

// ============================================================
// Header Style
// ============================================================
const thStyle = (col) => {
  const width = columnWidths.value[col.field] || col.width
  // GUARDIÃO: NÃO definir `position` inline — a posição (sticky) vem do CSS
  // (.admin-table th). Um `position: relative` inline sobrescreveria o sticky.
  const style = {}

  if (width) {
    style.width = typeof width === 'number' ? width + 'px' : width
  }

  if (col.align) {
    style.textAlign = col.align
  }

  return style
}

// ============================================================
// Sorting
// ============================================================
const handleHeaderClick = (col) => {
  let newField = col.field
  let newOrder = 'asc'

  if (props.sortField === col.field) {
    if (props.sortOrder === 'asc') {
      newOrder = 'desc'
    } else {
      // Se já está desc, limpa a ordenação
      newField = ''
      newOrder = ''
    }
  }

  // Se existe sortResolver, tenta ordenação client-side
  if (props.sortResolver && newField) {
    const sorted = props.sortResolver(newField, newOrder, [...props.data])
    if (sorted) {
      localData.value = sorted
      emit('update:sortField', newField)
      emit('update:sortOrder', newOrder)
      return
    }
  }

  // Fallback: emite sort-change para o backend
  emit('update:sortField', newField)
  emit('update:sortOrder', newOrder)
  emit('sort-change', { field: newField, order: newOrder })
}

// ============================================================
// Seleção de linha
// ============================================================
const internalSelectedKey = ref(props.selectedRowKey)

watch(() => props.selectedRowKey, (val) => {
  internalSelectedKey.value = val
})

function isRowSelected (row, rowIndex) {
  if (!props.selectable) return false
  const key = getRowKey(row, rowIndex)
  return internalSelectedKey.value !== null && internalSelectedKey.value !== undefined && internalSelectedKey.value === key
}

function toggleRowSelection (row, rowIndex) {
  const key = getRowKey(row, rowIndex)
  if (internalSelectedKey.value === key) {
    // Desseleciona
    internalSelectedKey.value = null
  } else {
    internalSelectedKey.value = key
  }
  emit('update:selectedRowKey', internalSelectedKey.value)
  emit('selected-row-change', { row, key: internalSelectedKey.value })
}

// ============================================================
// Click / Double-tap handler (Desktop + Mobile)
// ============================================================
const DOUBLE_TAP_THRESHOLD = 300 // ms
let lastTapTime = 0
let lastTapRow = null

const handleRowClick = (row, event) => {
  const now = Date.now()
  const isDoubleTap = (
    now - lastTapTime < DOUBLE_TAP_THRESHOLD &&
    lastTapRow !== null &&
    getRowKey(lastTapRow, -1) === getRowKey(row, -1)
  )

  if (isDoubleTap) {
    // Segundo toque dentro do limiar → duplo clique
    emit('row-dblclick', { row, event })
    lastTapTime = 0
    lastTapRow = null
    return
  }

  // Primeiro toque (ou toque único) → clique normal
  emit('row-click', { row, event })
  lastTapTime = now
  lastTapRow = row

  // Se selectable estiver ativo, alterna seleção
  if (props.selectable) {
    const rowIndex = localData.value.indexOf(row)
    toggleRowSelection(row, rowIndex)
  }
}

// ============================================================
// SISTEMA DE LAYOUTS CUSTOMIZÁVEIS
// ============================================================
const isLayoutModalOpen = ref(false)

// Colunas que serão efetivamente renderizadas (aplicando o layout salvo)
const colunasEfetivas = ref(props.columns ? [...props.columns] : [])

// ============================================================
// Seletor de colunas (popover)
// ============================================================
const showColunasSelector = ref(false)
const showExportMenu = ref(false)
const colunasOcultas = ref(new Set())

// ============================================================
// Overlays teleportados (z-index via registry central)
// ============================================================
const colunasPopoverStyle = ref({})
const exportarDropdownStyle = ref({})
const zIndexColunas = ref(BASE_ZINDEX)
const zIndexExportar = ref(BASE_ZINDEX)
const tokenZIndexColunas = ref(null)
const tokenZIndexExportar = ref(null)

const calcularPosicaoColunas = () => {
  const toolbar = toolbarRef.value
  if (!toolbar) {
    colunasPopoverStyle.value = {}
    return
  }
  const rect = toolbar.getBoundingClientRect()
  const popoverWidth = 520
  const popoverMaxHeight = 480
  let top = rect.top + 4
  let right = window.innerWidth - rect.right

  // Clamp horizontal: não pode sair da viewport
  const minRight = 8
  const maxRight = window.innerWidth - popoverWidth - 8
  right = Math.max(minRight, Math.min(right, maxRight))

  // Clamp vertical: se não couber abaixo, abre acima
  if (top + popoverMaxHeight > window.innerHeight - 8) {
    top = Math.max(8, rect.top - popoverMaxHeight + 28)
  }

  colunasPopoverStyle.value = {
    position: 'fixed',
    top: top + 'px',
    right: right + 'px',
    zIndex: zIndexColunas.value
  }
}

const calcularPosicaoExportar = () => {
  const btn = btnExportarRef.value
  if (!btn) {
    exportarDropdownStyle.value = {}
    return
  }
  const rect = btn.getBoundingClientRect()
  const dropdownWidth = 120
  const dropdownMaxHeight = 200
  let top = rect.bottom + 4
  let right = window.innerWidth - rect.right

  // Clamp horizontal
  const minRight = 8
  const maxRight = window.innerWidth - dropdownWidth - 8
  right = Math.max(minRight, Math.min(right, maxRight))

  // Clamp vertical
  if (top + dropdownMaxHeight > window.innerHeight - 8) {
    top = Math.max(8, rect.top - dropdownMaxHeight - 4)
  }

  exportarDropdownStyle.value = {
    position: 'fixed',
    top: top + 'px',
    right: right + 'px',
    zIndex: zIndexExportar.value
  }
}

// Progresso da exportação
const progressoPorcentagem = computed(() => {
  const { total, carregados } = props.exportandoProgresso
  if (!total) return 0
  return Math.min(100, Math.round((carregados / total) * 100))
})

// Filtros individuais para cada painel
const filtroDisponiveis = ref('')
const filtroSelecionados = ref('')

// Watches: reserva/libera z-index e reposiciona os overlays teleportados
watch(showColunasSelector, (aberto) => {
  if (aberto) {
    // Fecha o outro overlay
    showExportMenu.value = false
    const { token, zIndex: z } = reservarZIndex()
    tokenZIndexColunas.value = token
    zIndexColunas.value = z
    nextTick(() => calcularPosicaoColunas())
  } else {
    liberarZIndex(tokenZIndexColunas.value)
    tokenZIndexColunas.value = null
    filtroDisponiveis.value = ''
    filtroSelecionados.value = ''
  }
})

watch(showExportMenu, (aberto) => {
  if (aberto) {
    // Fecha o outro overlay
    showColunasSelector.value = false
    const { token, zIndex: z } = reservarZIndex()
    tokenZIndexExportar.value = token
    zIndexExportar.value = z
    nextTick(() => calcularPosicaoExportar())
  } else {
    liberarZIndex(tokenZIndexExportar.value)
    tokenZIndexExportar.value = null
  }
})

// Estado do drag-and-drop
const dragState = ref({ field: null, origin: null })

// Colunas renderizadas no grid (exclui as ocultas pelo seletor)
// A coluna de ações (field === 'acoes' ou 'actions') é SEMPRE incluída no final
const colunasRenderizadas = computed(() => {
  const visiveis = colunasEfetivas.value.filter(c => !colunasOcultas.value.has(c.field))
  const acoes = colunasEfetivas.value.find(c => c.field === 'acoes' || c.field === 'actions')
  if (acoes && !visiveis.some(c => c.field === acoes.field)) {
    return [...visiveis, acoes]
  }
  return visiveis
})

// Todos os campos visíveis (o pai decide como agrupar)
const visibleFields = computed(() =>
  colunasRenderizadas.value.map(c => c.field)
)

// Notifica o pai quando os campos visíveis mudam
watch(visibleFields, (campos) => {
  emit('group-by-changed', { visibleFields: [...campos] })
}, { deep: true })

// Fecha popovers ao clicar fora (com Teleport, os overlays estão no body)
function handleClickOutside (event) {
  if (showColunasSelector.value && !event.target.closest('.colunas-selector-popover') && !event.target.closest('.btn-colunas-selector')) {
    showColunasSelector.value = false
    filtroDisponiveis.value = ''
    filtroSelecionados.value = ''
  }
  if (showExportMenu.value && !event.target.closest('.exportar-dropdown') && !event.target.closest('.btn-exportar-wrapper')) {
    showExportMenu.value = false
  }
}

// Inicializa colunasOcultas a partir de colunasEfetivas
function initColunasOcultas () {
  colunasOcultas.value = new Set(
    colunasEfetivas.value
      .filter(c => c.visible === false)
      .map(c => c.field)
  )
}

// Base de colunas (exclui colunas de ação)
const colunasBase = computed(() => {
  if (props.colunasPadrao) return props.colunasPadrao
  if (props.columns) {
    return props.columns.filter(c => {
      if (c.field === 'acoes' || c.field === 'actions' || c.field?.startsWith('_')) return false
      return true
    })
  }
  return []
})

// Colunas Disponíveis: da base que estão em colunasOcultas
const colunasDisponiveis = computed(() => {
  return colunasBase.value.filter(c => colunasOcultas.value.has(c.field))
})

// Colunas Selecionadas: de colunasEfetivas que NÃO estão em colunasOcultas
const colunasSelecionadas = computed(() => {
  return colunasEfetivas.value.filter(c => !colunasOcultas.value.has(c.field))
})

// Disponíveis filtradas pelo texto
const colunasDisponiveisFiltradas = computed(() => {
  const termo = filtroDisponiveis.value.toLowerCase().trim()
  if (!termo) return colunasDisponiveis.value
  return colunasDisponiveis.value.filter(c =>
    c.label?.toLowerCase().includes(termo) || c.field?.toLowerCase().includes(termo)
  )
})

// Selecionados filtrados pelo texto
const colunasSelecionadasFiltradas = computed(() => {
  const termo = filtroSelecionados.value.toLowerCase().trim()
  if (!termo) return colunasSelecionadas.value
  return colunasSelecionadas.value.filter(c =>
    c.label?.toLowerCase().includes(termo) || c.field?.toLowerCase().includes(termo)
  )
})

// Alterna visibilidade de uma coluna (primeira coluna e fixas nunca são ocultadas)
function toggleColuna (field) {
  if (isPrimeiraColuna(field)) return
  if (isColunaFixa(field)) return
  const ocultas = new Set(colunasOcultas.value)
  if (ocultas.has(field)) {
    ocultas.delete(field)
  } else {
    ocultas.add(field)
  }
  colunasOcultas.value = ocultas
}

// Seleciona todas as colunas disponíveis (move para selecionados)
function selecionarTudo () {
  const ocultas = new Set(colunasOcultas.value)
  colunasDisponiveis.value.forEach(col => {
    if (!isPrimeiraColuna(col.field) && !isColunaFixa(col.field)) {
      ocultas.delete(col.field)
    }
  })
  colunasOcultas.value = ocultas
}

// Demarca todos os campos selecionados (move para disponíveis)
function demarcarTodos () {
  const ocultas = new Set(colunasOcultas.value)
  colunasSelecionadas.value.forEach(col => {
    if (!isPrimeiraColuna(col.field) && !isColunaFixa(col.field)) {
      ocultas.add(col.field)
    }
  })
  colunasOcultas.value = ocultas
}

// Move uma coluna para cima (-1) ou para baixo (+1) em colunasEfetivas
function moverColuna (field, direction) {
  // Colunas de ações e fixas não podem ser reposicionadas
  if (isColunaFixa(field)) return
  const idx = colunasEfetivas.value.findIndex(c => c.field === field)
  if (idx === -1) return
  const newIdx = idx + direction
  if (newIdx < 0 || newIdx >= colunasEfetivas.value.length) return
  // Não permite mover para a posição 0 se a primeira coluna estiver bloqueada
  if (props.bloquearPrimeiraColuna && newIdx === 0) return
  const arr = [...colunasEfetivas.value]
  const [removed] = arr.splice(idx, 1)
  arr.splice(newIdx, 0, removed)
  colunasEfetivas.value = arr
}

// Verifica se a coluna é a coluna de ações (field === 'acoes' ou 'actions')
function isColunaAcoes (field) {
  return field === 'acoes' || field === 'actions'
}

// Verifica se a coluna é a primeira selecionada
// Retorna false se bloquearPrimeiraColuna for false (desbloqueado)
function isPrimeiraColuna (field) {
  if (!props.bloquearPrimeiraColuna) return false
  return colunasSelecionadas.value.length > 0 && colunasSelecionadas.value[0].field === field
}

// Verifica se a coluna está na lista de fixas ou é a coluna de ações (não pode ser removida)
function isColunaFixa (field) {
  if (isColunaAcoes(field)) return true
  return props.colunasFixas.includes(field)
}

// Verifica se a coluna é a última selecionada
function isUltimaColuna (field) {
  const s = colunasSelecionadas.value
  return s.length > 0 && s[s.length - 1].field === field
}

// ============================================================
// Exportação (CSV / XLSX)
// ============================================================
function exportarDados (formato) {
  showExportMenu.value = false
  ultimoFormatoExport.value = formato
  emit('exportar-dados', formato)
}

const ultimoFormatoExport = ref('')

/**
 * Formata valor para CSV (tudo como string legível).
 * - ISO timestamp → "14/08/2026 17:58:21" (sem vírgula)
 * - ISO date     → "14/08/2026"
 * - Demais       → String(val)
 */
function formatValueForCSV (val) {
  if (typeof val === 'string') {
    // ISO timestamp: 2026-08-14T20:58:21.036882Z
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)) {
      const d = new Date(val)
      if (!isNaN(d.getTime())) {
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      }
    }
    // ISO date: 2026-08-14
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      const d = new Date(val + 'T12:00:00')
      if (!isNaN(d.getTime())) {
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
      }
    }
  }
  return String(val)
}

/**
 * Prepara valor para XLSX (preserva tipos para o Excel reconhecer).
 * - ISO timestamp → Date object (célula data/hora)
 * - ISO date     → Date object (célula data)
 * - number       → mantém como número
 * - Demais       → valor original (string)
 */
function formatValueForXLSX (val) {
  if (typeof val === 'string') {
    // ISO timestamp → Date object (Excel reconhece como data/hora corretamente)
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(val)) {
      const d = new Date(val)
      if (!isNaN(d.getTime())) return d
    }
    // ISO date → string legível (evita hora fantasma no LibreOffice)
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
      const d = new Date(val + 'T00:00:00Z')
      if (!isNaN(d.getTime())) {
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
      }
    }
  }
  // Números são preservados para o Excel tratar como numérico
  return val
}

// Watch: quando o pai envia os dados completos, gera o arquivo
watch(() => props.dadosExportar, (dados) => {
  if (!dados || !Array.isArray(dados) || dados.length === 0) return
  gerarArquivo(dados)
}, { deep: false })

function gerarArquivo (dados) {
  try {
    if (!dados || dados.length === 0) {
      emit('show-notification', { message: 'Nenhum dado para exportar.', type: 'warning' })
      return
    }

    // Filtra apenas colunas visíveis e não-ação
    const colunas = colunasEfetivas.value.filter(c =>
      !colunasOcultas.value.has(c.field) &&
      c.field !== 'acoes' && c.field !== 'actions' && !c.field?.startsWith('_')
    )

    const cabecalhos = colunas.map(c => c.label || c.field)
    const timestamp = Date.now()
    const fmt = ultimoFormatoExport.value

    // Metadados para incluir no cabeçalho do arquivo
    const dataExtracao = new Date().toLocaleString('pt-BR')
    const titulo = props.tituloExportacao || 'Exportação de dados'
    const filtros = props.filtrosExportacao || 'Nenhum filtro aplicado'

    // Nome do arquivo: título + timestamp
    const nomeBase = titulo.replace(/[^a-zA-Z0-9_\- ]/g, '').trim().replace(/\s+/g, '_')

    if (fmt === 'csv') {
      // CSV: metadados como linhas prefixadas
      const linhas = dados.map(row =>
        colunas.map(c => {
          const val = campoResolvido(row, c.field)
          if (val == null) return ''
          if (c.formatter) return String(c.formatter(val, row))
          return formatValueForCSV(val)
        })
      )

      const linhasMetadados = [
        `"Relatório: ${titulo.replace(/"/g, '""')}"`,
        `"Data de extração: ${dataExtracao}"`,
        `"Filtros: ${filtros.replace(/"/g, '""')}"`,
        ''
      ]
      const csvContent = [
        ...linhasMetadados,
        cabecalhos.join(','),
        ...linhas.map(l => l.map(v => `"${v.replace(/"/g, '""')}"`).join(','))
      ].join('\n')
      const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' })
      baixarArquivo(blob, `${nomeBase}_${timestamp}.csv`)
      emit('show-notification', { message: `CSV gerado com ${dados.length} registos.`, type: 'success' })
    }

    if (fmt === 'xlsx') {
      // XLSX: preserva tipos (Date, number, string) para o Excel reconhecer corretamente
      const linhas = dados.map(row =>
        colunas.map(c => {
          const val = campoResolvido(row, c.field)
          if (val == null) return ''
          if (c.formatter) return c.formatter(val, row) // sem String() — preserva tipo
          return formatValueForXLSX(val)
        })
      )

      // Linhas de metadados antes do cabeçalho
      const linhasMetadados = [
        [`Relatório: ${titulo}`],
        [`Data de extração: ${dataExtracao}`],
        [`Filtros: ${filtros}`],
        []
      ]

      // Gera a planilha com metadados + cabeçalho + dados
      const ws = XLSX.utils.aoa_to_sheet([...linhasMetadados, cabecalhos, ...linhas])

      // Mescla células do título na primeira linha para ocupar toda a largura
      const ultimaColuna = cabecalhos.length - 1
      if (ultimaColuna >= 0) {
        ws['!merges'] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: ultimaColuna } },
          { s: { r: 1, c: 0 }, e: { r: 1, c: ultimaColuna } },
          { s: { r: 2, c: 0 }, e: { r: 2, c: ultimaColuna } }
        ]
      }

      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Dados')
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
      const blob = new Blob([wbout], { type: 'application/octet-stream' })
      baixarArquivo(blob, `${nomeBase}_${timestamp}.xlsx`)
      emit('show-notification', { message: `XLSX gerado com ${dados.length} registos.`, type: 'success' })
    }

    ultimoFormatoExport.value = ''
  } catch (e) {
    console.error('[AdminTable] Erro ao gerar arquivo:', e)
    emit('show-notification', { message: 'Erro ao gerar arquivo de exportação.', type: 'error' })
    ultimoFormatoExport.value = ''
  }
}

function baixarArquivo (blob, nomeArquivo) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = nomeArquivo
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

// ============================================================
// Drag & Drop — Item-level
// ============================================================
const dragOverField = ref(null)

function onDragStart (field, origin) {
  dragState.value = { field, origin }
}

function onDragOverPane (_pane) {
  // Necessário para permitir drop no corpo do painel (quando não há itens)
}

function onDragOverItem (field, _pane) {
  dragOverField.value = field
}

function onDragLeaveItem () {
  dragOverField.value = null
}

function onDropItem (targetField, targetPane) {
  dragOverField.value = null
  const { field, origin } = dragState.value
  if (!field || field === targetField) return

  if (origin === 'disponiveis' && targetPane === 'selecionados') {
    // Arrastou de Disponíveis → item dos Selecionados: ativa e insere na posição
    const ocultas = new Set(colunasOcultas.value)
    ocultas.delete(field)
    colunasOcultas.value = ocultas

    const arr = [...colunasEfetivas.value]
    const fromIdx = arr.findIndex(c => c.field === field)
    const toIdx = arr.findIndex(c => c.field === targetField)
    if (fromIdx >= 0 && toIdx >= 0) {
      const [removed] = arr.splice(fromIdx, 1)
      const newIdx = arr.findIndex(c => c.field === targetField)
      // Não permite mover para a posição 0 se a primeira coluna estiver bloqueada
      if (props.bloquearPrimeiraColuna && newIdx === 0) return
      if (newIdx >= 0) arr.splice(newIdx, 0, removed)
      colunasEfetivas.value = arr
    }
  } else if (origin === 'selecionados' && targetPane === 'selecionados') {
    // Reordenou dentro de Selecionados: insere na posição do target
    const arr = [...colunasEfetivas.value]
    const fromIdx = arr.findIndex(c => c.field === field)
    const toIdx = arr.findIndex(c => c.field === targetField)
    if (fromIdx >= 0 && toIdx >= 0 && fromIdx !== toIdx) {
      const [removed] = arr.splice(fromIdx, 1)
      const newIdx = arr.findIndex(c => c.field === targetField)
      // Não permite mover para a posição 0 se a primeira coluna estiver bloqueada
      if (props.bloquearPrimeiraColuna && newIdx === 0) return
      if (newIdx >= 0) arr.splice(newIdx, 0, removed)
      colunasEfetivas.value = arr
    }
  }

  dragState.value = { field: null, origin: null }
}

function onDropPane (targetPane) {
  dragOverField.value = null
  const { field, origin } = dragState.value
  if (!field) return

  if (origin === 'disponiveis' && targetPane === 'selecionados') {
    // Drop no vazio dos Selecionados: ativa e vai para o fim
    toggleColuna(field)
  } else if (origin === 'selecionados' && targetPane === 'disponiveis') {
    // Drop nos Disponíveis: desativa
    toggleColuna(field)
  }

  dragState.value = { field: null, origin: null }
}

// Snapshot da configuração atual (colunas + sort) para passar ao modal
// Considera colunasOcultas para refletir a visibilidade atual
const layoutAtualSnapshot = computed(() => ({
  colunas: colunasEfetivas.value.map((c, idx) => ({
    field: c.field,
    label: c.label,
    width: columnWidths.value[c.field] || c.width || null,
    order: idx,
    visible: !colunasOcultas.value.has(c.field),
    sortable: c.sortable !== false,
    align: c.align || 'left',
    slotName: c.slotName || null
  })),
  sortField: props.sortField,
  sortOrder: props.sortOrder
}))

/**
 * Aplica um layout recebido do modal (configuração de colunas + sort).
 * @param {Object} layout - { colunas: [...], sortField, sortOrder }
 */
const aplicarLayoutExterno = (layout) => {
  if (!layout || !Array.isArray(layout.colunas)) return

  const colunasVisiveis = layout.colunas.filter((c) => c.visible !== false)

  // Reordena pela propriedade 'order'
  const colunasOrdenadas = [...colunasVisiveis].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

  // Mapeia para a definição original de colunas (preservando slots/formatters)
  // Usa props.columns (que contém slotName, formatters etc.) em vez de colunasPadrao
  const colunasFonte = props.columns || []
  const mapaOriginal = new Map(colunasFonte.map((c) => [c.field, c]))
  const novasColunas = colunasOrdenadas.map((c) => {
    const original = mapaOriginal.get(c.field) || colunasFonte.find((p) => p.field === c.field) || {}
    return {
      ...original,
      field: c.field,
      label: original.label || c.label || c.field,
      width: c.width || original.width,
      align: c.align || original.align || 'left',
      sortable: c.sortable !== false,
      resizable: original.resizable !== false
    }
  })

  // Mantém colunas que não estão no mapa (ex: slots dinâmicos), garantindo ordem
  const colunasRestantes = colunasFonte.filter(
    (c) => !colunasOrdenadas.some((l) => l.field === c.field)
  )
  colunasEfetivas.value = [...novasColunas, ...colunasRestantes]

  // Garante que a coluna de ações (field === 'acoes' ou 'actions') fique sempre no final
  const idxAcoes = colunasEfetivas.value.findIndex(c => c.field === 'acoes' || c.field === 'actions')
  if (idxAcoes >= 0 && idxAcoes < colunasEfetivas.value.length - 1) {
    const [acoes] = colunasEfetivas.value.splice(idxAcoes, 1)
    colunasEfetivas.value.push(acoes)
  }

  // Sincroniza colunasOcultas com a visibilidade definida no layout aplicado
  const ocultas = new Set(
    layout.colunas
      .filter(c => c.visible === false)
      .map(c => c.field)
  )
  colunasOcultas.value = ocultas

  // Aplica widths explícitos
  columnWidths.value = {}
  colunasOrdenadas.forEach((c) => {
    if (c.width) columnWidths.value[c.field] = Number(c.width)
  })

  // Aplica ordenação salva
  if (layout.sortField) {
    emit('update:sortField', layout.sortField)
    emit('update:sortOrder', layout.sortOrder || 'asc')
    emit('sort-change', { field: layout.sortField, order: layout.sortOrder || 'asc' })
  }
}

const abrirGerenciadorLayout = () => {
  showColunasSelector.value = false
  showExportMenu.value = false
  isLayoutModalOpen.value = true
}

// ============================================================
// Carga automática do layout default (se moduloLayout estiver definido)
// ============================================================
const onReposicionarOverlays = () => {
  if (showColunasSelector.value) calcularPosicaoColunas()
  if (showExportMenu.value) calcularPosicaoExportar()
}

onMounted(async () => {
  initColunasOcultas()
  document.addEventListener('click', handleClickOutside)
  window.addEventListener('scroll', onReposicionarOverlays, { capture: true })
  window.addEventListener('resize', onReposicionarOverlays, { capture: true })

  // Detector de overflow horizontal (thead sticky × scroll-x)
  nextTick(() => {
    checarOverflowX()
    const container = tableContainerRef.value
    const table = tableRef.value
    if (container && table && typeof ResizeObserver !== 'undefined') {
      _overflowObserver = new ResizeObserver(() => checarOverflowX())
      _overflowObserver.observe(container)
      _overflowObserver.observe(table)
    }
  })

  if (!props.moduloLayout) return
  try {
    const { data } = await layoutService.getDefault(props.moduloLayout)
    if (data && data.configuracaoColunas) {
      const colunasConfig = JSON.parse(data.configuracaoColunas)
      aplicarLayoutExterno({
        colunas: colunasConfig,
        sortField: data.sortField,
        sortOrder: data.sortOrder
      })
    }
  } catch (e) {
    console.warn('[AdminTable] Falha ao carregar layout default:', e)
  }
})
</script>

<style scoped>
/* ============================================================
   AdminTable — Estilos Escopados
   Usa as mesmas classes .admin-table / .admin-table-container
   para ser compatível com os :deep() do PaginaAdministrar.
   ============================================================ */

/* ============================================================
   Wrapper externo: contém a toolbar + container de scroll
   ============================================================ */
.admin-table-outer-wrapper {
  position: relative;
}

/* ============================================================
   Toolbar acima do grid: fora do scroll horizontal
   Transparente e minimalista — reserva espaço no layout
   para que o botão não invada o header do PaginaAdministrar.
   ============================================================ */
.admin-table-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 32px;
  /*
   * GUARDIÃO: toolbar sticky para os botões (layout/colunas/exportar) ficarem
   * SEMPRE visíveis quando o thead do grid congela abaixo do header do
   * PaginaAdministrar. Fundo opaco (body-bg) para cobrir as linhas que passam
   * por trás ao rolar. z-index acima do thead (4) e abaixo do admin-header (10).
   */
  position: sticky;
  top: var(--ct-admin-header-h, 0px);
  z-index: 5;
  background-color: var(--bs-body-bg);
}

/* ============================================================
   Botão de Gerenciamento de Layout
   Esmaecido por padrão; firma quando o mouse está sobre a
   toolbar/tabela ou quando o modal está aberto.
   ============================================================ */
.btn-layout-config {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  background-color: transparent;
  color: #6c757d;
  opacity: 0.35;
  cursor: pointer;
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 20;
  transition: opacity 0.2s ease, color 0.2s ease, border-color 0.2s ease, background-color 0.2s ease;
}

/* Botão de engrenagem (seletor de colunas) fica à esquerda do de layout */
.btn-colunas-selector {
  right: 32px;
}

/* ============================================================
   Botão de exportar e dropdown
   ============================================================ */
.btn-exportar-wrapper {
  position: absolute;
  top: 4px;
  right: 60px;
  z-index: 20;
}

.btn-exportar {
  position: static !important;
}

.exportar-dropdown {
  min-width: 120px;
  background: var(--bs-body-bg, #fff);
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.375rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  overflow: hidden;
  margin-top: 4px;
}

.exportar-opcao {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 6px 12px;
  border: none;
  background: transparent;
  color: var(--bs-body-color, #212529);
  font-size: 0.8rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
  text-align: left;
}

.exportar-opcao:hover {
  background-color: var(--bs-tertiary-bg, #f8f9fa);
}

.exportar-opcao:first-child {
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}

/* ============================================================
   Barra de progresso da exportação
   ============================================================ */
.exportar-progresso-wrapper {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  z-index: 25;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
}

.exportar-progresso-bar {
  flex: 1;
  height: 6px;
  background: var(--bs-secondary-bg, #e9ecef);
  border-radius: 3px;
  overflow: hidden;
}

.exportar-progresso-fill {
  height: 100%;
  background: var(--bs-primary, #0d6efd);
  border-radius: 3px;
  transition: width 0.3s ease;
}

.exportar-progresso-texto {
  font-size: 0.7rem;
  color: var(--bs-secondary-color, #6c757d);
  white-space: nowrap;
}

/* ============================================================
   Popover de seleção de colunas — Dual Pane
   ============================================================ */
.colunas-selector-popover {
  width: 520px;
  max-height: 480px;
  background: var(--bs-body-bg, #fff);
  border: 1px solid var(--bs-border-color, #dee2e6);
  border-radius: 0.375rem;
  box-shadow: 0 4px 16px rgba(0,0,0,0.12);
  overflow: hidden;
}

.colunas-selector-panes {
  display: flex;
  height: 100%;
  max-height: 480px;
}

/* ============================================================
   Cada painel (Disponíveis / Selecionados)
   ============================================================ */
.colunas-pane {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  border-right: 1px solid var(--bs-border-color, #dee2e6);
}

.colunas-pane:last-child {
  border-right: none;
}

.pane-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 8px;
  background: var(--bs-tertiary-bg, #f8f9fa);
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
  flex-shrink: 0;
}

.pane-title {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--bs-body-color, #212529);
  white-space: nowrap;
}

.pane-count {
  font-size: 0.65rem;
  padding: 1px 6px;
  border-radius: 8px;
  background: var(--bs-secondary-bg, #e9ecef);
  color: var(--bs-secondary-color, #6c757d);
}

/* Container de ações no header do painel */
.pane-header-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Botão "Selecionar tudo" / "Demarcar todos" nos painéis */
.btn-pane-select-all,
.btn-pane-deselect-all {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  background: transparent;
  color: var(--bs-secondary-color, #6c757d);
  font-size: 0.65rem;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease;
  line-height: 1;
  opacity: 0.4;
}

.btn-pane-select-all:hover,
.btn-pane-deselect-all:hover {
  opacity: 1;
  color: var(--bs-primary, #0d6efd);
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-color: var(--bs-border-color, #dee2e6);
}

.pane-filter-input {
  width: 100%;
  padding: 4px 6px;
  font-size: 0.75rem;
  border: none;
  border-bottom: 1px solid var(--bs-border-color, #dee2e6);
  background: var(--bs-body-bg, #fff);
  color: var(--bs-body-color, #212529);
  outline: none;
  flex-shrink: 0;
}

.pane-filter-input:focus {
  background: var(--bs-tertiary-bg, #f8f9fa);
}

.pane-body {
  flex: 1;
  overflow-y: auto;
  padding: 2px 0;
  min-height: 80px;
}

.pane-item {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 3px 6px;
  cursor: default;
  transition: background-color 0.12s ease;
  border-radius: 0;
}

.pane-item:hover {
  background-color: var(--bs-tertiary-bg, #f8f9fa);
}

.pane-item-fixed {
  background-color: var(--bs-warning-bg-subtle, #fff3cd);
}

.pane-item-fixed:hover {
  background-color: var(--bs-warning-bg-subtle, #fff3cd);
}

/* Indicador visual de drop (linha azul acima do item) */
.pane-item-drop-before {
  box-shadow: inset 0 2px 0 var(--bs-primary, #0d6efd);
}

.pane-item-text {
  font-size: 0.8rem;
  color: var(--bs-body-color, #212529);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  min-width: 0;
}
.pane-star {
  font-size: 0.8rem;
  line-height: 1;
  flex-shrink: 0;
}

.pane-lock {
  font-size: 0.8rem;
  line-height: 1;
  flex-shrink: 0;
  opacity: 0.7;
}

.pane-empty {
  padding: 20px 8px;
  text-align: center;
  font-size: 0.75rem;
  color: var(--bs-secondary-color, #6c757d);
}

/* ============================================================
   Botões de seta + drag handle
   ============================================================ */
.pane-item-arrows {
  display: flex;
  gap: 1px;
  flex-shrink: 0;
  opacity: 0.3;
  transition: opacity 0.15s ease;
}

.pane-item:hover .pane-item-arrows {
  opacity: 1;
}

.btn-arrow-colunas {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 0.2rem;
  background: transparent;
  color: var(--bs-secondary-color, #6c757d);
  font-size: 0.55rem;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
  line-height: 1;
}

.btn-arrow-colunas:hover:not(:disabled) {
  color: var(--bs-primary, #0d6efd);
  background-color: var(--bs-tertiary-bg, #f8f9fa);
  border-color: var(--bs-border-color, #dee2e6);
}

.btn-arrow-colunas:disabled {
  opacity: 0.15;
  cursor: default;
}

.drag-handle {
  font-size: 0.8rem;
  color: var(--bs-secondary-color, #6c757d);
  cursor: grab;
  flex-shrink: 0;
  padding: 0 2px;
  opacity: 0.3;
  transition: opacity 0.15s ease;
}

.pane-item:hover .drag-handle {
  opacity: 0.7;
}

.drag-handle:active {
  cursor: grabbing;
}

.admin-table-outer-wrapper:hover .btn-layout-config {
  opacity: 0.85;
  color: #34495E;
  border-color: rgba(52, 73, 94, 0.2);
  background-color: rgba(52, 73, 94, 0.05);
}

.btn-layout-config:hover {
  opacity: 1 !important;
  color: #fff !important;
  border-color: #34495E !important;
  background-color: #34495E !important;
}

.btn-layout-config-visible {
  opacity: 0.85 !important;
  color: #34495E !important;
  border-color: rgba(52, 73, 94, 0.2) !important;
  background-color: rgba(52, 73, 94, 0.05) !important;
}

/* ============================================================
   Sticky Column — Coluna de Ações congelada à direita
   Ativado quando há uma linha selecionada no grid
   Apenas o td da linha selecionada fica sticky (não o cabeçalho)
   ============================================================ */
.admin-table-container.has-sticky-actions .admin-table tr.selected .td-actions {
  position: sticky;
  right: 0;
  z-index: 3;
  background: var(--bs-body-bg, #fff) !important;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.06);
  overflow: visible;
}

.admin-table-container {
  position: relative;
  /*
   * GUARDIÃO: sem overflow no base (desktop) para o thead sticky referenciar
   * a página (e congelar abaixo do header do PaginaAdministrar). A classe
   * .table-overflows-x — aplicada por ResizeObserver — reativa o scroll
   * horizontal APENAS quando a tabela excede a largura do container.
   */
}
/*
 * OPÇÃO A — Tabela larga (overflow horizontal):
 * o container passa a rolar em X, o que o torna um scroll container e faz o
 * `position: sticky` do cabeçalho referenciar ele (sem scroll em Y) — nesse
 * caso o `top` vira DESLOCAMENTO (empurra o header para baixo). Por isso,
 * quando a tabela estoura a largura, desligamos o congelamento do th e da
 * toolbar: a tabela rola em X e o header acompanha a página normalmente.
 */
.admin-table-outer-wrapper.table-overflows-x .admin-table-container {
  overflow-x: auto;
}
.admin-table-outer-wrapper.table-overflows-x .admin-table th {
  position: relative;
  top: auto;
}
.admin-table-outer-wrapper.table-overflows-x .admin-table-toolbar {
  position: static;
}

/* table-layout: fixed é OBRIGATÓRIO para que o resize JS
   funcione sem o navegador redistribuir larguras automaticamente.
   Usamos scoped para não afetar tabelas manuais existentes. */
.admin-table {
  table-layout: fixed;
}

/* overflow: hidden + text-overflow: ellipsis evitam que o conteudo
   de uma coluna avance sobre a coluna vizinha quando excede a largura. */
.admin-table td {
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ============================================================
   Row Selection
   ============================================================ */
.admin-table tr.selected {
  background-color: rgba(var(--bs-primary-rgb, 13, 110, 253), 0.08) !important;
  outline: 2px solid var(--bs-primary, #0d6efd);
  outline-offset: -2px;
}

.admin-table tr.selected:hover {
  background-color: rgba(var(--bs-primary-rgb, 13, 110, 253), 0.12) !important;
}

/* ============================================================
   Ações por linha — Modo Híbrido
   - Linhas não selecionadas: hover nativo (PaginaAdministrar)
   - Linha selecionada: botões sempre visíveis e opacos, sticky
   ============================================================ */

/* Linha selecionada: botões ficam sempre visíveis (opacity: 1),
   independente do hover. Sobrescreve :deep(tr:hover .acoes-wrapper). */
.admin-table tr.selected :deep(.acoes-wrapper) {
  opacity: 1 !important;
}

/* A área da coluna de ações da linha selecionada fica com fundo opaco */
.admin-table tr.selected .td-actions {
  background: var(--bs-body-bg, #fff) !important;
}

/* ============================================================
   Header Column Divider (sempre visível)
   Dá a noção visual de que é ali que se arrasta para redimensionar.
   ============================================================ */
.admin-table th {
  border-right: 1px solid var(--bs-border-color, #dee2e6);
  /*
   * GUARDIÃO: cabeçalho do grid congelado logo abaixo do header do
   * PaginaAdministrar (--ct-admin-header-h) + da toolbar (--ct-toolbar-h).
   * position: sticky também serve de containing block para o resize-handle.
   */
  position: sticky;
  top: calc(var(--ct-admin-header-h, 0px) + var(--ct-toolbar-h, 0px));
  z-index: 4;
  overflow: hidden;
}

.admin-table th:last-child {
  border-right: none;
}

/* ============================================================
   Header Sorting
   ============================================================ */
.th-content {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.th-label {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
  line-height: 1.2;
  min-width: 0;
}

.th-sortable .th-content {
  cursor: pointer;
  user-select: none;
}

.th-sortable:hover .th-label {
  color: var(--bs-primary);
}

.th-sorted .sort-indicator {
  color: var(--bs-primary);
}

.sort-indicator {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  line-height: 1;
}

/* ============================================================
   Resize Handle
   Sobrepõe a border-right do th. No hover ganha destaque.
   ============================================================ */
.resize-handle {
  position: absolute;
  top: 0;
  right: -1px;
  bottom: 0;
  width: 7px;
  cursor: col-resize;
  z-index: 2;
  background: transparent;
  transition: background-color 0.15s ease;
}

.resize-handle:hover,
.resize-handle:active {
  background-color: var(--bs-primary);
  opacity: 0.4;
}

/* Evita seleção de texto durante o arrasto */
.admin-table-container.is-resizing {
  user-select: none;
  -webkit-user-select: none;
}

.admin-table-container.is-resizing .resize-handle {
  opacity: 0.4;
  background-color: var(--bs-primary);
}

/* ============================================================
   Loading Overlay
   ============================================================ */
.admin-table-container.table-loading::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(var(--bs-body-bg-rgb), 0.6);
  z-index: 5;
}

/* ============================================================
   Responsivo: scroll horizontal em telas estreitas
   Em vez de comprimir as colunas igualmente (table-layout: fixed),
   a tabela assume width: max-content e o container scrolla.
   O resize continua funcional porque as larguras explícitas
   em pixel são respeitadas mesmo com table-layout: auto.
   ============================================================ */
@media (max-width: 991.98px) {
  .admin-table-container {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .admin-table {
    table-layout: auto;
    width: max-content;
    min-width: 100%;
  }

  .admin-table td {
    white-space: nowrap;
  }

  .admin-table th {
    white-space: normal;
  }

  /* No mobile o botão fica sempre visível (não depende de hover) */
  .btn-layout-config {
    opacity: 0.6;
    color: #34495E;
  }
}
</style>
